<template>
  <div class="content-contents container-fluid">
    <v-col class="col-sm-12 col-lg-8 offset-lg-2 col">
      <v-tabs v-model="activeTab">
        <template>
          <v-row class="tabs-nav-container">
            <v-col class="col-12">
              <v-tab
                v-for="tabButton in tabs"
                :key="tabButton.title"
                class="tab-header"
                disabled
                :href="tabButton.href"
              >
                <v-icon>{{ tabButton.icon }}</v-icon>
                {{ tabButton.title }}
              </v-tab>
            </v-col>
          </v-row>
          <v-row class="pe-6 ps-6">
            <v-col class="col-12">
              <v-progress-linear
                color="#203f39"
                height="7"
                background-color="#dee2e6"
                :value="progress"
                striped
              ></v-progress-linear>
            </v-col>
          </v-row>
          <v-row class="pe-6 ps-6">
            <v-col class="col-12">
              <v-tabs-items v-model="activeTab">
                <v-tab-item value="tab-1">
                  <user-info-tab
                    :complaint-obj="complaintObj"
                    @changeTab="(tb)=>changeActiveTab(tb)"
                    @cancel="cancelComplaint"
                  ></user-info-tab>
                </v-tab-item>
                <v-tab-item value="tab-2">
                  <complaint-category-tab
                    v-if="complaintCategories && complaintCategories.length >0"
                    :complaint-obj="complaintObj"
                    :complaint-categories="complaintCategories"
                    @changeTab="(tb)=>changeActiveTab(tb)"
                    @cancel="cancelComplaint"
                  ></complaint-category-tab>
                </v-tab-item>
                <v-tab-item value="tab-3">
                  <complaint-details-tab
                    :complaint-obj="complaintObj"
                    @changeTab="(tb)=>changeActiveTab(tb)"
                    @cancel="cancelComplaint"
                  ></complaint-details-tab>
                </v-tab-item>
                <v-tab-item value="tab-4">
                  <complaint-preview-tab
                    :complaint-obj="complaintObj"
                    @changeTab="(tb)=>changeActiveTab(tb)"
                    @cancel="cancelComplaint"
                    @submit="(number)=>savedComplaint(number)"
                  ></complaint-preview-tab>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </template>
      </v-tabs>
    </v-col>
    <naj-confirmation
      :show-modal="showConfirmation"
      :action-loading="loading"
      :color="actionModal.color"
      :title="actionModal.title"
      :message="actionModal.message"
      :ok-btn-label="actionModal.okBtn"
      :close-btn-label="actionModal.closeBtn"
      @ok="actionModal.proceedSubmit"
      @cancel="actionModal.proceedCancel"
    ></naj-confirmation>
  </div>
</template>

<script>
import ComplaintDetailsTab from './complaintDetailsTab.vue';
import UserInfoTab from './userInfoTab.vue';
import ComplaintCategoryTab from './complaintCategoryTab.vue';
import ComplaintPreviewTab from './complaintPreviewTab.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions, mapState: mapComplaintsState } = createNamespacedHelpers('ComplaintsModule');
export default {
  name: 'NewComplaint',
  components: {
    ComplaintDetailsTab,
    UserInfoTab,
    ComplaintCategoryTab,
    ComplaintPreviewTab,
  },
  props: {},
  data() {
    return {
      activeTab: 'tab-1',
      progress: 25,
      loading: false,
      showConfirmation: false,
      actionModal: {
        proceedSubmit: () => { },
        proceedCancel: () => { },
      },
      complaintObj: {
        selected: false,
        selectedCategoryId: null,
        subCategoryId: null,
        subCategories: [],
        executionVerificationObj: {},
        executionRequestInfo: {},
        resetFormModel: (reloadForm) => {
          this.complaintObj.executionVerificationObj = {};
          this.complaintObj.reloadForm = reloadForm;
          this.complaintObj.complaintForm.formModel.executionRequestInfo = {};
          this.complaintObj.complaintForm.formModel.executionVerificationObj = {};
          Object.keys(this.complaintObj.complaintForm.formModel)
            .forEach((key) => {
              if (key != 'selectedCase' && key != 'viewMode' && key != 'executionRequestInfo' && key != 'executionVerificationObj')
                delete this.complaintObj.complaintForm.formModel[key];
            }
            );
        },
        complaintForm: {
          formModel: {
            selectedCase: null,
            viewMode: false,
          },
          formFields: [],
          customComponentName: '',
        },
      },
    };
  },
  computed: {
    ...mapComplaintsState([
      'complaintCategories',
    ]),
    tabs() {
      return [
        {
          href: '#tab-1',
          progress: 25,
          title: this.local.complaints.newComplaint.userInfoTab.title,
          icon: 'mdi-account',
        },
        {
          href: '#tab-2',
          progress: 50,
          title: this.local.complaints.newComplaint.complaintCategoryTab.title,
          icon: 'mdi-list-box-outline',
        },
        {
          href: '#tab-3',
          progress: 75,
          title: this.local.complaints.newComplaint.complaintDetailsTab.title,
          icon: 'mdi-format-list-bulleted-square',
        }
        ,
        {
          href: '#tab-4',
          progress: 100,
          title: this.local.complaints.newComplaint.complaintPreviewTab.title,
          icon: 'mdi-eye-outline',
        },
      ];
    },
  },
  watch: {},
  created() {
  },
  mounted() {
    this.getComplaintCategories();
  },
  methods: {
    ...mapComplaintsActions([
      'getComplaintCategories',
    ]),
    changeTab(tb) {
      this.progress = tb.progress;
    },
    changeActiveTab(tb) {
      this.activeTab = tb;
      this.progress = this.tabs.filter(tab => tab.href == '#' + tb)
        .map(item => item.progress)[0];
    },
    cancelComplaint() {
      this.showConfirmation = true;
      this.actionModal = {
        color: 'error',
        title: this.local.complaints.newComplaint.userInfoTab.cancelTitle,
        message: null,
        okBtn: this.local.common.yes,
        closeBtn: this.local.common.no,
        proceedCancel: () => {
          this.showConfirmation = false;
        },
        proceedSubmit: () => {
          this.actionModal = {
            color: 'success',
            title: this.local.complaints.newComplaint.userInfoTab.confirmCancelTitle,
            message: this.local.complaints.newComplaint.userInfoTab.confirmCancelMessage,
            closeBtn: this.local.breadcrumbs.mainPage,
            okBtn: null,
            proceedSubmit: () => { },
            proceedCancel: () => {
              this.$router.push('/');
            },
          };
        },
      };
    },
    savedComplaint(complaintId) {
      this.showConfirmation = true;
      this.actionModal = {
        color: 'success',
        title: this.local.complaints.newComplaint.userInfoTab.successComplaintTitle,
        message: this.local.complaints.newComplaint.userInfoTab.successComplaintMessage(complaintId),
        closeBtn: this.local.breadcrumbs.mainPage,
        okBtn: null,
        proceedSubmit: () => { this.$router.push('/'); },
        proceedCancel: () => { this.$router.push('/'); },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.tab-header {
  height: 60px;
}
::v-deep .v-slide-group__wrapper {
  overflow: visible !important;
  contain: initial;
  display: unset !important;
}
::v-deep {
  .v-slide-group__content {
    display: block;
  }
  .v-tabs {
    box-shadow: 0 0.75rem 6rem rgba(56, 65, 74, 0.03);
    margin-bottom: 1.5rem;
    border-radius: 0.25rem;
    display: flex;
    flex-direction: column;
    .v-tabs-bar {
      flex: 1 1 auto;
      padding-block: 1.5rem;
    }
    .tabs-nav-container {
      margin-right: 0;
      margin-left: 0;
      > div {
        display: flex;
        flex-wrap: wrap;
        padding-inline: 0;
      }
      .tab-header {
        height: auto;
        flex-basis: 0;
        flex-grow: 1;
        text-align: center;
        width: auto;
        font-weight: 500;
        padding: 0.75rem 1rem;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
          border-color 0.15s ease-in-out;
        background-color: #f7f7f7;
        border: 2px solid #fff;
        color: #b69a70;
        .v-icon {
          color: #b69a70;
          margin-inline-end: 6px;
          font-size: 1.25em;
        }
        &.v-tab--active {
          color: #fff;
          background-color: #203f39;
          .v-icon {
            color: #fff;
          }
        }
        &.v-tab--disabled {
          opacity: 100 !important;
        }
      }
    }

    .v-progress-linear--striped .v-progress-linear__determinate {
      transition: width 0.6s ease;
      background-image: linear-gradient(
        -45deg,
        rgba(255, 255, 255, 0.15) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 255, 255, 0.15) 75%,
        transparent 75%,
        transparent
      );
      background-size: 0.75rem 0.75rem;
      animation: 1s linear infinite progress-bar-stripes;
    }
    .v-tabs-slider-wrapper {
      display: none;
    }
  }
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.75rem;
  }
}
</style>
